/**
 * Duplicates the backend's live usages: no type is shared between the two applications. A model
 * carrying one of these usages must be delivered in real time, and these values are a subset of
 * `AUDIO_USAGES`.
 */
const LIVE_USAGES: readonly string[] = ['live_interview_transcription', 'live_dictation'];

export default LIVE_USAGES;
